"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _faq = require("block/faq");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _class, _descriptor, _descriptor2, _temp;

var FaqGroupBlock = (_class = (_temp =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(FaqGroupBlock, _Block);

  function FaqGroupBlock() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, FaqGroupBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(FaqGroupBlock)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "questions", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "groupTitle", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(FaqGroupBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "container title-container"
      }, _react.default.createElement("h1", null, this.groupTitle)), this.questions.map(function (question) {
        return _react.default.createElement(_react.Fragment, {
          key: question.id
        }, _react.default.createElement(_faq.FaqItem, question));
      }));
    }
  }]);
  return FaqGroupBlock;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "questions", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "groupTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = FaqGroupBlock;